module.exports = __webpack_public_path__ + "img/icons_38.9ca449d8.svg";